import { ChargeModuleDetailsModel, PackageModuleDetailModel, PackageModuleViewModel, PackageType, SurgeryLinkModel } from "@admin/masters/pages/package-modules/models";
import { Component, Input, OnChanges, OnDestroy, ViewEncapsulation } from "@angular/core";
import { ApiResources } from "@shared/helpers";
import { IResource, Page } from "@shared/models";
import { HttpService } from "@shared/services";
import { finalize, takeUntil } from "rxjs/operators";
import { IAdmissionPackageModuleModel } from "../../../../../services/models/admission-package.model";

@Component({
    templateUrl: "./view-package-module.html",
    selector: "view-package-module",
    styleUrls: ['./view-package-module.css'],
    encapsulation: ViewEncapsulation.None
})
export class ViewPackageModuleComponent implements OnChanges, OnDestroy {
    packageType = PackageType;

    @Input() packageModuleId: number;
    @Input() packageModuleIds: string;
    @Input() isCounselling: boolean;
    @Input() chargeCategory!: IResource;
    @Input() hidePrice!: boolean;
    @Input() isShow: boolean;
    @Input() packages: Array<IAdmissionPackageModuleModel>;
    @Input() showReport: boolean;
    page: Page;
    loading: boolean;
    packageInfo: PackageModuleViewModel;
    packageDetails: Array<PackageModuleDetailModel>;
    packageInfoAll: Array<PackageModuleViewModel>;
    packageInfoForServices: PackageModuleViewModel;
    loadingChargeCategories: boolean;
    chargeCategories: Array<IResource>;
    loadingCharges: boolean;
    charges: Array<ChargeModuleDetailsModel>;
    hidePrices: boolean;
    showChargeCategories: boolean;

    surgeryLinkServices: Array<SurgeryLinkModel>;

    constructor(private readonly httpService: HttpService) {
        this.page = new Page();
        this.packageInfoAll = new Array<PackageModuleViewModel>();
        this.surgeryLinkServices = new Array<SurgeryLinkModel>();
    }

    ngOnChanges(): void {
        if (this.packages && this.packages.length > 0 && this.showReport) {
            this.findPackageInfo(null,this.packageModuleIds);
        }
        else if (this.packages && this.packages.length > 0) {
            this.packages.forEach(item => {
                this.findPackageInfo(item.packageModuleId);
            })
        }
        else {

            this.findPackageInfo();
        }
    }

    fetchPackageDetails(modulesMasterId: number): Array<PackageModuleDetailModel> {
        return this.packageInfo.packageModuleDetails.filter(m => m.modulesMasterId === modulesMasterId) || [];
    }

    fetchSurgeries(surgeryId: number) {
        return this.surgeryLinkServices.filter(m => m.surgeryId === surgeryId) || [];
    }

    fetchPackageDetailsAll(modulesMasterId: number, packModel: PackageModuleViewModel): Array<PackageModuleDetailModel> {
        return packModel.packageModuleDetails.filter(m => m.modulesMasterId === modulesMasterId) || [];
    }

    onSelectChargeCategory(chargeCategoryId: number): void {
        if (chargeCategoryId) {
            this.chargeCategory = this.chargeCategories.find(m => m.id === chargeCategoryId);
            this.fetchCharges();
        }
    }

    onClearChargeCategory(): void {
        this.packageInfo.totalQuantity = 0;
        this.packageInfo.freeQuantity = 0;
        this.packageInfo.discount = 0;
        this.packageInfo.subTotal = 0;
        this.packageInfo.freeQuantityTotal = 0;
        this.packageInfo.total = 0;
        this.packageInfo.packageModuleDetails.every(m => m.isNA = false);
    }

    ngOnDestroy(): void {
        this.page.unsubscribeAll();
    }
    private findPackageInfo(id?: number, packageModuleIds?: string): void {
        this.loading = true;
        let requestBody = {}
        if (this.showReport) {
            requestBody = Object.assign({ packageModuleIds: this.packageModuleIds });
        } else {
            requestBody = Object.assign({ packageModuleId: id ? id : this.packageModuleId });
        }
        let moduleId = { packageModuleId: id ? id : (this.packageModuleId > 0 ? this.packageModuleId : null) };
        if (moduleId == null) {
            return;
        }
        if (this.showReport) {
            this.httpService
                .get(ApiResources.getURI(ApiResources.packageModule.base, ApiResources.packageModule.detailReport), requestBody)
                .pipe(finalize(() => this.loading = false), takeUntil(this.page.unSubscribe))
                .subscribe({
                    next: (response: PackageModuleViewModel) => {
                        this.packageInfo = response;

                    }
                });
        }
        else {
            this.httpService
                .get(ApiResources.getURI(ApiResources.packageModule.base, ApiResources.packageModule.view), requestBody)
                .pipe(finalize(() => this.loading = false), takeUntil(this.page.unSubscribe))
                .subscribe({
                    next: (response: PackageModuleViewModel) => {
                        this.packageInfo = response;
                        if (this.isCounselling) {
                            this.fetchCharges();
                        } else {
                            if (this.packageInfo?.packageModule?.packageType === "O") {
                                this.chargeCategory = this.packageInfo.chargeCategory;
                                this.fetchCharges();
                            }
                            else if (this.chargeCategory) {
                                this.setChareCategoryTotals(this.chargeCategory);
                                this.fetchChargeCategories();
                                this.fetchCharges();
                            }
                            else
                                this.fetchChargeCategories();
                        }
                        this.packageInfoAll.push(this.packageInfo);
                    },
                    error: () => this.packageInfo = undefined
                });
        }
    }
    private fetchChargeCategories(): void {
        this.showChargeCategories = true;
        const requestBody = {
            chargeModuleTemplateId: this.packageInfo.packageModule.chargeModuleTemplateId,
            locationId: this.packageInfo.packageModule.locationId,
            packageModuleId: this.packageInfo.packageModule.packageModuleId
        };

        this.loadingChargeCategories = true;
        this.httpService
            .get(ApiResources.getURI(ApiResources.packageModule.base, ApiResources.packageModule.fetchChargeCategoriesWithTotal), requestBody)
            .pipe(finalize(() => this.loadingChargeCategories = false), takeUntil(this.page.unSubscribe))
            .subscribe({
                next: (chargeCategories: Array<IResource>) => {
                    if (chargeCategories.length) {
                        chargeCategories.forEach((chargeCategory: IResource) => {
                            this.setChareCategoryTotals(chargeCategory);
                        });
                    }

                    this.chargeCategories = chargeCategories;
                    if (this.chargeCategory) {
                        this.chargeCategory = this.chargeCategories.find(s => s.id == this.chargeCategory.id);
                    }
                },
                error: () => this.chargeCategories = []
            });
    }

    private setChareCategoryTotals(chargeCategory: IResource): void {
        let subTotal = chargeCategory.value ? parseFloat(chargeCategory.value) : 0, discount = 0, total = subTotal;
        if (this.packageInfo.packageModule.discountType === "P") {
            discount = parseFloat((((subTotal * (this.packageInfo.packageModule.discountPercentage || 0)) / 100) || 0).toFixed(2));
            discount = isNaN(discount) ? 0 : discount;
            total = subTotal - discount;
            total = total > 0 ? total : 0;
        } else if (this.packageInfo.packageModule.discountType === "A") {
            discount = this.packageInfo.packageModule.discountAmount || 0;
            discount = isNaN(discount) ? 0 : discount;
            total = subTotal - discount;
            total = total > 0 ? total : 0;
        }

        chargeCategory.subTotal = subTotal;
        chargeCategory.discount = discount;
        chargeCategory.total = total;
    }


    fetchLinkedServices = (callback?: Function) => {
        this.packageDetails = this.packageInfo.packageModuleDetails.filter(m => !m.isNA);
        if (this.isShow && this.packageDetails && this.packageDetails.length > 0) {
            var surgeryIds = "";
            var modulesMasterId;
            this.packageDetails.forEach(item => {
                if (item.moduleName === 'OT') {
                    modulesMasterId = item.modulesMasterId;
                    surgeryIds += item.referenceId + ",";
                }
            })
            const req = {
                chargeCategoryId: this.chargeCategory.id,
                chargeModuleTemplateId: this.packageInfo.packageModule.chargeModuleTemplateId,
                locationId: this.packageInfo.packageModule.locationId,
                modulesMasterId: modulesMasterId,
                surgeryIds: surgeryIds
            }
            this.loadingCharges = true;

            this.httpService
                .post(ApiResources.getURI(ApiResources.packageModule.base, ApiResources.packageModule.fetchServiceLinkCharges), req)
                .pipe(finalize(() => this.loadingCharges = false), takeUntil(this.page.unSubscribe))
                .subscribe(
                    (response: Array<SurgeryLinkModel>) => {
                        this.surgeryLinkServices = response;
                        callback && callback(this.surgeryLinkServices);
                    }
                )

        }

    }
    //For backup
    //fetchLinkedServices = ( callback?: Function) =>  {
    //    this.packageDetails = this.packageInfo.packageModuleDetails.filter(m => !m.isNA );
    //    if (this.isShow && this.packageDetails && this.packageDetails.length > 0) {
    //        this.packageDetails.forEach(item => {
    //            if (item.moduleName === 'OT') {
    //                var surgeryIds = "";
    //                surgeryIds += item.referenceId + ",";
    //                const req = {
    //                    chargeCategoryId: this.chargeCategory.id,
    //                    chargeModuleTemplateId: this.packageInfo.packageModule.chargeModuleTemplateId,
    //                    locationId: this.packageInfo.packageModule.locationId,
    //                    referenceId: item.referenceId,
    //                    modulesMasterId: item.modulesMasterId
    //                }
    //                this.loadingCharges = true;

    //                this.httpService
    //                    .post(ApiResources.getURI(ApiResources.packageModule.base, ApiResources.packageModule.fetchServiceLinkCharges), req)
    //                    .pipe(finalize(() => this.loadingCharges = false), takeUntil(this.page.unSubscribe))
    //                    .subscribe(
    //                        (response: Array<SurgeryLinkModel>) => {

    //                                response.forEach(linkService => {

    //                                    this.surgeryLinkServices.push(linkService);

    //                                })
    //                                item.amount = item.amount + this.surgeryLinkServices.filter(m => m.surgeryId == item.referenceId).map(m => m.amount).reduce((sum, current) => sum + current, 0)
    //                        }
    //                    )
    //            }

    //        })

    //    }
    //    callback && callback(this.surgeryLinkServices);
    //}


    private fetchCharges(): void {
        const requestBody = {
            chargeCategoryId: this.chargeCategory.id,
            chargeModuleTemplateId: this.packageInfo.packageModule.chargeModuleTemplateId,
            locationId: this.packageInfo.packageModule.locationId,
            packageModuleId: this.packageInfo.packageModule.packageModuleId,
            modulesMasterIds: this.packageInfo.packageModule.modulesMasterIds
        };

        this.loadingCharges = true;
        this.httpService
            .post(ApiResources.getURI(ApiResources.packageModule.base, ApiResources.packageModule.fetchChargeDetails), requestBody)
            .pipe(finalize(() => this.loadingCharges = false), takeUntil(this.page.unSubscribe))
            .subscribe({
                next: (charges: Array<ChargeModuleDetailsModel>) => {
                    this.charges = charges;
                    if (charges && charges.length) {
                        this.packageInfo.packageModuleDetails.forEach(m => {
                            if (m.referenceId) {
                                const charge = charges.find(n => n.modulesMasterId === m.modulesMasterId && n.referenceId === m.referenceId);
                                if (charge) {
                                    m.isNA = false;
                                    m.amount = charge.amount;
                                }
                                else
                                    m.isNA = true;
                            } else
                                m.isNA = false;
                        });
                        if (this.isShow) {

                            this.fetchLinkedServices(() => {
                                setTimeout(() => {
                                    this.packageInfo.packageModuleDetails = this.packageDetails;

                                    this.packageDetails.forEach(item => {
                                        if (item.moduleName === 'OT') {
                                            item.serviceTotal = item.amount;
                                            item.amount = item.amount + this.surgeryLinkServices.filter(m => m.surgeryId == item.referenceId).map(m => m.amount).reduce((sum, current) => sum + current, 0)
                                        }
                                    })
                                    const packageDetails = this.packageInfo.packageModuleDetails.filter(m => !m.isNA);
                                    this.packageInfo.totalQuantity = packageDetails.map(m => m.quantity).reduce((sum, current) => sum + current, 0);
                                    this.packageInfo.subTotal = packageDetails.map(m => m.amount).reduce((sum, current) => sum + current, 0);

                                    let subTotal = this.packageInfo.subTotal || 0, discount = 0, total = subTotal;
                                    if (this.packageInfo.packageModule.discountType === "P") {
                                        discount = parseFloat((((subTotal * (this.packageInfo.packageModule.discountPercentage || 0)) / 100) || 0).toFixed(2));
                                        discount = isNaN(discount) ? 0 : discount;
                                        total = subTotal - discount;
                                        total = total > 0 ? total : 0;
                                    } else if (this.packageInfo.packageModule.discountType === "A") {
                                        discount = this.packageInfo.packageModule.discountAmount || 0;
                                        discount = isNaN(discount) ? 0 : discount;
                                        total = subTotal - discount;
                                        total = total > 0 ? total : 0;
                                    }
                                    this.packageInfo.discount = discount;
                                    this.packageInfo.total = total;
                                    this.packageInfoForServices = this.packageInfo;
                                })
                            })
                        }

                        else {
                            this.packageInfo.packageModuleDetails = this.packageDetails;
                            const packageDetails = this.packageInfo.packageModuleDetails.filter(m => !m.isNA);

                            this.packageInfo.totalQuantity = packageDetails.map(m => m.quantity).reduce((sum, current) => sum + current, 0);
                            this.packageInfo.subTotal = packageDetails.map(m => m.amount).reduce((sum, current) => sum + current, 0);

                            let subTotal = this.packageInfo.subTotal || 0, discount = 0, total = subTotal;
                            if (this.packageInfo.packageModule.discountType === "P") {
                                discount = parseFloat((((subTotal * (this.packageInfo.packageModule.discountPercentage || 0)) / 100) || 0).toFixed(2));
                                discount = isNaN(discount) ? 0 : discount;
                                total = subTotal - discount;
                                total = total > 0 ? total : 0;
                            } else if (this.packageInfo.packageModule.discountType === "A") {
                                discount = this.packageInfo.packageModule.discountAmount || 0;
                                discount = isNaN(discount) ? 0 : discount;
                                total = subTotal - discount;
                                total = total > 0 ? total : 0;
                            }

                            this.packageInfo.discount = discount;
                            this.packageInfo.total = total;
                            this.packageInfoForServices = this.packageInfo;

                        }
                    }
                },
                error: () => this.charges = []
            });
    }



}
